import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import { Helmet } from "react-helmet";
import RoomPreferencesOutlinedIcon from '@mui/icons-material/RoomPreferencesOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import DomainVerificationRoundedIcon from '@mui/icons-material/DomainVerificationRounded';
import DrawRoundedIcon from '@mui/icons-material/DrawRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import DatasetLinkedRoundedIcon from '@mui/icons-material/DatasetLinkedRounded';
import packageJson from "../../../package.json";
import "./settings.scss"

const Settings = () => {

    const { logout, user, hasPermission } = useContext(AuthContext);

    return (
        <div className="settings">
            <Helmet>
                <title>Einstellungen</title>
            </Helmet>
            <div className="container">
                <div className="header">
                    <h1>Einstellungen</h1>
                    <span>Verwalte deine Konto und Systemeinstellungen</span>
                </div>
                <div className="layout">
                    <div className="group profile">
                        <div className="info">
                            <span className="badge">{user.username?.[0]}</span>
                            <div className="data">
                                <span className="user">
                                    <bold>{user.name} {user.surname}</bold>
                                </span>
                                <span className="email">
                                    <span>{user.email}</span>
                                </span>
                            </div>
                        </div>
                        <Link onClick={logout} className="logout">
                            <LogoutOutlinedIcon />
                        </Link>
                    </div>
                    {hasPermission("data", "read") &&
                        <div className="group">
                            <h4>Seiten</h4>
                            <div className="grid">
                                {hasPermission("data", "read") &&
                                    <Link to="/data/users">
                                        <DatasetLinkedRoundedIcon className="icon" />
                                        <div className="data">
                                            <span>Stammdaten</span>
                                            <span className="small">Benutzer, Fuhrpark, Tracker verwalten</span>
                                        </div>
                                        <ArrowForwardIosRoundedIcon className="arrow" />
                                    </Link>
                                }
                                {hasPermission("tankstelle", "read") &&
                                    <Link to="/tankstelle">
                                        <LocalGasStationIcon className="icon" />
                                        <div className="data">
                                            <span>Tankstelle</span>
                                            <span className="small">Lade- und Tankvorgänge verwalten</span>
                                        </div>
                                        <ArrowForwardIosRoundedIcon className="arrow" />
                                    </Link>
                                }
                                {hasPermission("sign", "read") &&
                                    <Link to="/sign">
                                        <DrawRoundedIcon className="icon" />
                                        <div className="data">
                                            <span>Sign</span>
                                            <span className="small">Digitale Unterschrift</span>
                                        </div>
                                        <ArrowForwardIosRoundedIcon className="arrow" />
                                    </Link>
                                }
                            </div>
                        </div>
                    }
                    <div className="group">
                        <h4>Voreinstellungen</h4>
                        <span className="description">Benutzerdefinierte Einstellungen</span>
                        <div className="list">
                            {hasPermission("map", "read") &&
                                <div className="item">
                                    <QueryStatsRoundedIcon className="icon" />
                                    <div className="data">
                                        <span>Fahrzeugliste Karte Parameter</span>
                                    </div>
                                    <div className="checkbox">
                                        <div className="box">
                                            <div className="check on"></div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="group">
                        <h4>Benutzer</h4>
                        <span className="description">Systemparameter auf einem Blick</span>
                        <div className="list">
                            {hasPermission("sign", "write") &&
                                <div className="item">
                                    <DrawRoundedIcon className="icon" />
                                    <div className="data">
                                        <span>Lieferschein Serie Digitale Unterschrift</span>
                                    </div>
                                    <input
                                        className="value"
                                        type="text"
                                        value={1}
                                    />
                                </div>
                            }
                            <div className="item">
                                <ManageAccountsOutlinedIcon className="icon" />
                                <div className="data">
                                    <span>ERGO Mitarbeiter ID</span>
                                </div>
                                <input
                                    className="value"
                                    type="text"
                                    disabled
                                    value={user.employeeId || "-"}
                                />
                            </div>
                            <div className="item">
                                <ApartmentOutlinedIcon className="icon" />
                                <div className="data">
                                    <span>ERGO Kunden ID</span>
                                </div>
                                <input
                                    className="value"
                                    type="text"
                                    disabled
                                    value={user.companyId || "-"}
                                />
                            </div>
                            <div className="item">
                                <RoomPreferencesOutlinedIcon className="icon" />
                                <div className="data">
                                    <span>Startseite</span>
                                </div>
                                <input
                                    className="value"
                                    type="text"
                                    disabled
                                    value={user.landingPage || "-"}
                                />
                            </div>
                            <div className="item">
                                <DomainVerificationRoundedIcon className="icon" />
                                <div className="data">
                                    <span>App Version</span>
                                </div>
                                <input
                                    className="value"
                                    type="text"
                                    disabled
                                    value={packageJson.version}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;